module.exports = __webpack_public_path__ + "static/media/one-third.4158568f.svg";